/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { useHasPermission } from "../../hooks/useHasPermission";

/* Components */
import UCButton from "../buttons";
import { ReactComponent as PaymentIcon } from "../../resources/images/aa-policy-rounded.svg"
import CreatePolicyModal from "../modals/createPolicyModal";

/* Styles */
import styles from "./styles.js"


const PolicyNoData = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  const [showCreatePolicyModal, setShowCreatePolicyModal] = useState(false);
  const { checkPermission } = useHasPermission();

  const handleAddPolicy = () => {
    setShowCreatePolicyModal(true)
  }

  return (
    <div className={classes.policyWrapper}>
      <div className={classes.logo}>
          <PaymentIcon/>
      </div>
      <h1><FormattedMessage id="policyNoPolicies.title"/></h1>
      <p><FormattedMessage id="policyNoPolicies.description"/></p>
      {
        checkPermission("F_ADD_POLICY") &&
        <UCButton
          type="primary"
          onClick={() => handleAddPolicy()}
          className={classes.addPolicyBtn}
          text={<FormattedMessage id="policy.addBtn"/>}
      />
      }
      <CreatePolicyModal 
        showCreatePolicyModal={showCreatePolicyModal}
        setShowCreatePolicyModal={setShowCreatePolicyModal}
      />
    </div>
  )
}

export default PolicyNoData;